import React, { useEffect, useContext } from "react"
import ProductDeatil from '@/templates/product.tsx';
import Home from '@/templates/index.tsx';
import './404.scss';
import { LayoutContext } from '@components/Context';
import { isBrowser } from "@/lib/utils";

const NotFoundPage = () => {
  const isProduct = isBrowser ? window.location.pathname.indexOf('product') >= 0 : false;

  const layoutContext = useContext(LayoutContext)
  useEffect(() => {
    if (isProduct) {
      layoutContext?.updateShowLayout(false);
      layoutContext?.updateWidthAuto(true);
    }
    return () => {
      layoutContext?.updateShowLayout(true);
    }
  }, [])

  return (
      <div className='p-404-page'>
          {isProduct ? <ProductDeatil /> : <Home />}
      </div>
  )
}

export default NotFoundPage
